import { motion } from "framer-motion";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface MessagesShimmerProps {
  count?: number;
  className?: string;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 90,
      damping: 14,
      mass: 0.8,
    },
  },
};

export const MessagesShimmer = ({ count = 3, className }: MessagesShimmerProps) => (
  <motion.div
    variants={containerVariants}
    initial="hidden"
    animate="visible"
    className={cn("w-full space-y-4", className)}
  >
    {Array(count)
      .fill(null)
      .map((_, i) => (
        <motion.div
          // eslint-disable-next-line react/no-array-index-key
          key={`shimmer_${i}`}
          variants={itemVariants}
          className="group flex h-full w-full flex-col gap-y-1 rounded-lg px-3 py-3"
        >
          <div className="flex items-center justify-between gap-x-2 pb-2">
            <div className="flex w-full items-center gap-x-2">
              <Skeleton className="h-8 w-[140px] rounded-md bg-gray-100/80" />
              {i % 2 === 0 && <Skeleton className="h-8 w-[100px] rounded-md bg-gray-100/50" />}
            </div>
            <div className="flex gap-x-2">
              <Skeleton className="h-8 w-8 rounded-md bg-gray-100/50" />
              <Skeleton className="h-8 w-8 rounded-md bg-gray-100/50" />
            </div>
          </div>
          <div className="relative flex h-full w-full flex-col gap-y-1">
            <Skeleton
              className={cn(
                "w-full rounded bg-gray-100/60",
                i === 0 ? "min-h-[180px]" : "min-h-[110px]",
              )}
            />
          </div>

          {i === 0 && (
            <div className="mt-3 grid grid-cols-4 gap-3">
              {[1, 2, 3, 4].map(mediaIndex => (
                <Skeleton
                  key={`media_${mediaIndex}`}
                  className="h-24 w-full rounded-md bg-gray-100/50"
                />
              ))}
            </div>
          )}
        </motion.div>
      ))}
  </motion.div>
);

export default MessagesShimmer;
